export default "__VITE_ASSET__d7922767__"